/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
// import FeesContainer from './fees/container/FeesContainer';
import CmsComponents from './CmsComponents';
import RequirementsTagging from './requirements/container/RequirementsTagging';

function CdlSettingsContainer({ match, pathName }) {
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/cedula/settings/requirements"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('/cedula/settings/requirements') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Requirements
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link
                  to="/cedula/settings/fees"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('cedula/settings/fees') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Fees
                </Link>
              </li> */}
              <li className="nav-item">
                <Link
                  to="/cedula/settings/cms"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('cedula/settings/cms') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  CMS
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="card p-0">
          <Switch>
            {/* <Route
              path={`${match.path}/fees`}
              component={FeesContainer}
            /> */}
            <Route
              path={`${match.path}/requirements`}
              component={RequirementsTagging}
            />
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/cms`} />}
            />
            <Route
              exact
              path={`${match.path}/cms`}
              component={CmsComponents}
            />
          </Switch>
        </div>
      </div>
    </React.Fragment>
  );
}

CdlSettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(CdlSettingsContainer);
